import type { ThemeConfig } from 'antd';

// Premium Airline Dashboard Theme
export const antdTheme: ThemeConfig = {
  token: {
    // Primary Colors
    colorPrimary: '#2563eb',
    colorPrimaryHover: '#3b82f6',
    colorPrimaryActive: '#1d4ed8',
    colorPrimaryBg: '#eff6ff',
    colorPrimaryBgHover: '#dbeafe',
    colorPrimaryBorder: '#93c5fd',
    colorPrimaryText: '#2563eb',
    colorPrimaryTextHover: '#3b82f6',
    colorPrimaryTextActive: '#1d4ed8',

    // Status Colors
    colorSuccess: '#10b981',
    colorSuccessBg: '#ecfdf5',
    colorSuccessBorder: '#6ee7b7',
    colorWarning: '#f59e0b',
    colorWarningBg: '#fffbeb',
    colorWarningBorder: '#fcd34d',
    colorError: '#ef4444',
    colorErrorBg: '#fef2f2',
    colorErrorBorder: '#fca5a5',
    colorInfo: '#3b82f6',
    colorInfoBg: '#eff6ff',
    colorInfoBorder: '#93c5fd',

    // Background Colors
    colorBgContainer: '#ffffff',
    colorBgLayout: 'transparent',
    colorBgElevated: '#ffffff',
    colorBgSpotlight: 'rgba(0, 0, 0, 0.85)',

    // Text Colors
    colorText: '#1f2937',
    colorTextSecondary: '#6b7280',
    colorTextTertiary: '#9ca3af',
    colorTextQuaternary: '#d1d5db',

    // Border
    colorBorder: '#e5e7eb',
    colorBorderSecondary: '#f3f4f6',

    // Other - NO BORDER RADIUS
    borderRadius: 0,
    borderRadiusLG: 0,
    borderRadiusSM: 0,
    borderRadiusXS: 0,
    fontFamily: `'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif`,
    fontSize: 14,
    controlHeight: 40,
    boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1), 0 1px 2px rgba(0, 0, 0, 0.06)',
    boxShadowSecondary: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
  },
  components: {
    Layout: {
      siderBg: 'transparent',
      headerBg: 'transparent',
      headerPadding: '0 24px',
      headerHeight: 64,
      bodyBg: 'transparent',
    },
    Menu: {
      darkItemBg: 'transparent',
      darkSubMenuItemBg: 'transparent',
      darkItemSelectedBg: 'linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)',
      darkItemColor: 'rgba(255, 255, 255, 0.7)',
      darkItemHoverColor: '#ffffff',
      darkItemHoverBg: 'rgba(255, 255, 255, 0.08)',
      itemMarginInline: 12,
      itemPaddingInline: 12,
      itemBorderRadius: 0,
      subMenuItemBorderRadius: 0,
      iconSize: 18,
      collapsedIconSize: 18,
    },
    Card: {
      paddingLG: 24,
      borderRadiusLG: 0,
      borderRadius: 0,
      boxShadowTertiary: '0 4px 24px rgba(0, 0, 0, 0.08)',
    },
    Table: {
      headerBg: '#ffffff',
      headerColor: '#6b7280',
      headerSplitColor: 'transparent',
      rowHoverBg: '#f8fafc',
      borderColor: '#f1f5f9',
      cellPaddingBlock: 16,
      cellPaddingInline: 16,
      headerBorderRadius: 0,
      borderRadius: 0,
      borderRadiusLG: 0,
    },
    Button: {
      primaryShadow: '0 2px 8px rgba(37, 99, 235, 0.35)',
      defaultBorderColor: '#e5e7eb',
      borderRadius: 0,
      controlHeight: 40,
      controlHeightLG: 48,
      controlHeightSM: 32,
      paddingContentHorizontal: 20,
    },
    Input: {
      borderRadius: 0,
      controlHeight: 40,
      paddingInline: 14,
    },
    Select: {
      borderRadius: 0,
      controlHeight: 40,
    },
    DatePicker: {
      borderRadius: 0,
    },
    Tag: {
      borderRadiusSM: 0,
    },
    Upload: {
      borderRadiusLG: 0,
    },
    Checkbox: {
      borderRadiusSM: 0,
    },
    Radio: {
      borderRadius: 0,
    },
    Switch: {
      trackHeight: 22,
    },
    Tabs: {
      borderRadius: 0,
    },
    Collapse: {
      borderRadiusLG: 0,
    },
    Tooltip: {
      borderRadiusLG: 0,
    },
    Message: {
      borderRadiusLG: 0,
    },
    Notification: {
      borderRadiusLG: 0,
    },
    Breadcrumb: {
      itemColor: '#6b7280',
      lastItemColor: '#1f2937',
      linkColor: '#6b7280',
      linkHoverColor: '#2563eb',
      separatorColor: '#d1d5db',
    },
    Modal: {
      borderRadiusLG: 0,
      paddingContentHorizontalLG: 24,
    },
    Dropdown: {
      borderRadiusLG: 0,
      paddingBlock: 8,
      controlItemBgHover: '#f3f4f6',
    },
    Popover: {
      borderRadiusLG: 0,
    },
    Badge: {
      dotSize: 8,
    },
    Avatar: {
      borderRadius: 50,
    },
    Statistic: {
      titleFontSize: 14,
      contentFontSize: 28,
    },
  },
};

export default antdTheme;
